import React, { useMemo } from "react";
import { Stack, Box, CircularProgress } from "@mui/material";
import Chart from "react-apexcharts";
import colors from "../../../../../utils/colors";
import useHome from "../../../../../hooks/user/useHome";
import { withApexChartFont } from "../../../../../utils/apexChartDefaults";

const CircleOptions = withApexChartFont({
  chart: {
    type: "radialBar",
    offsetY: -80,
    sparkline: {
      enabled: false,
    },
  },
  plotOptions: {
    radialBar: {
      startAngle: -108,
      endAngle: 108,
      hollow: {
        margin: 50,
        size: "0%",
        background: "#fff",
        position: "front",
      },
      track: {
        background: "#D4D4D4",
        strokeWidth: "50%",
        margin: 50, // margin is in pixels
        dropShadow: {
          enabled: false,
        },
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          offsetY: 5,
          fontSize: "28px",
          fontWeight: "bold",
        },
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 0,
    },
  },
  colors: ["#FFDB43"],
  stroke: {
    lineCap: "round",
  },
});

const AreaOptions = withApexChartFont({
  chart: {
    type: "area",
    offsetY: -120,
    zoom: { enabled: false },
    toolbar: { show: false },
  },
  colors: ["#FFDB43"],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
    width: 2,
  },
  xaxis: {
    type: "datetime",
    labels: {
      datetimeUTC: false,
      style: { fontSize: "12px", colors: "#696969" },
    },
    axisBorder: { show: true },
    axisTicks: { show: false },
    tickAmount: 2, // shows left + middle + right ticks in many datasets
  },
  yaxis: {
    show: false,
  },
  grid: {
    show: true,
    borderColor: "#e6e6e6",
    strokeDashArray: 0,
    xaxis: { lines: { show: false } },
    yaxis: {
      lines: { show: false }, // show horizontal grid lines
    },
  },
  legend: { show: false },
  tooltip: {
    y: {
      formatter: (value) => `${value}%`,
    },
  },
});

const WebSecurityScore = () => {
  const { webSecurityScoreHistory } = useHome();

  const circleSeries = useMemo(() => {
    return [webSecurityScoreHistory?.[0]?.score ?? 0];
  }, [webSecurityScoreHistory]);

  const areaSeries = useMemo(() => {
    return [
      {
        name: "Web Security Score",
        data: [...(webSecurityScoreHistory ?? [])].reverse()?.map((item) => {
          return [new Date(item?.date), item?.score];
        }),
      },
    ];
  }, [webSecurityScoreHistory]);

  return webSecurityScoreHistory === null ? (
    <Stack alignItems={"center"} justifyContent={"center"} sx={{ height: "100%" }}>
      <CircularProgress sx={{ color: colors.neutral[400] }} />
    </Stack>
  ) : (
    <Stack>
      <Chart options={CircleOptions} series={circleSeries} type="radialBar" height={320} />
      <Box sx={{ px: 3 }}>
        <Chart options={AreaOptions} series={areaSeries} type="area" height={105} />
      </Box>
    </Stack>
  );
};
export default WebSecurityScore;
